/**
 * GPS class
 */
const GPS = {
  errorMessages: {
    not_support         : 'このブラウザではGPS機能がサポートされていません。',
    permission_denied   : 'GPS機能の利用権限がありません。',
    position_unavailable: 'GPS情報は利用できません。',
    timeout             : '現在地の特定に時間がかかりタイムアウトしました。',
    unknown             : '不明なエラーが発生しました。',
  },

  /**
   * Get current position
   *
   * @param resole
   * @param reject
   */
  geolocation(resole, reject) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(resole, reject);
      return;
    }
    reject(null);
  },

  /**
   * Adjust position
   *
   * @param position
   * @return object
   */
  getPosition(position) {
    return {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };
  },

  /**
   * Get error message
   *
   * @param error
   * @return {string}
   */
  getError(error) {
    if (error === null) {
      return this.errorMessages.not_support;
    }
    switch (error.code) {
      case error.PERMISSION_DENIED:
        return this.errorMessages.permission_denied;
      case error.POSITION_UNAVAILABLE:
        return this.errorMessages.position_unavailable;
      case error.TIMEOUT:
        return this.errorMessages.timeout;
      default:
        return this.errorMessages.unknown;
    }
  },
};

export default GPS;
